import { Subject, Observable } from 'rxjs';
import { Settable, Watchable } from './configAttributeInterfaces';

export class SimpleConfigObservable<T1, T2> implements Settable<T1, T2>, Watchable<T1, T2> {
  protected _source: Subject<null | T2>;

  constructor(
    protected _context: T1,
  ) {
    this._source = new Subject<null | T2>();
  }

  public context(): T1 {
    return this._context;
  }

  public set(value: null | T2 = null): T1 {
    this._source.next(value);
    return this._context;
  }
  public watch(): Observable<null | T2> {
    return this._source.asObservable();
  }
}
